import * as swcHelpers from '@swc/helpers';
import { actions } from '@grandvisionhq/state';
import { startPrescriptionGlassesConfiguration } from '../actions.js';
import { fetchLensTypesSuccess, fetchPackagesSuccess, fetchAddOnsSuccess } from '../bundles/actions.js';

const indexBySku = (m, p)=>{
    if (!p.masterVariant.sku) {
        return m;
    }
    return swcHelpers.objectSpread({}, m, {
        [p.masterVariant.sku]: p
    });
};
const reduceProducts = (products)=>products.reduce(indexBySku, {})
;
const initialState = {
    frames: {},
    lensTypes: {},
    variants: {},
    packages: {},
    addOns: {}
};
const reduceVariant = (masterSku)=>(m, variant)=>{
        if (!variant.sku || !variant.isMatchingVariant) {
            return m;
        }
        return swcHelpers.objectSpread({}, m, {
            [variant.sku]: masterSku
        });
    }
;
const indexAllVariantsBySKU = (m, product)=>{
    const { sku: masterSku  } = product.masterVariant;
    if (!masterSku) {
        return m;
    }
    return swcHelpers.objectSpread({}, m, {
        // We also record a reference for the masterVariant to make lookups simpler
        [masterSku]: masterSku
    }, product.variants.reduce(reduceVariant(masterSku), {}));
};
const addToLookup = (s, products)=>swcHelpers.objectSpread({}, s.variants, products.reduce(indexAllVariantsBySKU, {}))
;
const reducer = actions.reducer(initialState, actions.on(fetchLensTypesSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, reduceProducts(products)),
        variants: addToLookup(s, products)
    })
), actions.on(fetchPackagesSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, reduceProducts(products))
    })
), actions.on(fetchAddOnsSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, reduceProducts(products)),
        variants: addToLookup(s, products)
    })
), actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frame , frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        frames: swcHelpers.objectSpread({}, s.frames, {
            [frameSku]: frame
        })
    })
));

export { initialState, reducer };
//# sourceMappingURL=reducer.js.map
